
export const VALID_URL_REGEX = /^(?:http(s)?:\/\/)?.*$/;

// Requires a dot in the domain (e.g. rejects "user@gmail", accepts "user@gmail.com").
// Angular's built-in Validators.email does not enforce this.
export const EMAIL_WITH_TLD_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
